import DiscountLabelNew from './DiscountLabelNew'

export default DiscountLabelNew
